const PROOF_IMAGE =
  "https://images.unsplash.com/photo-1514168757508-07ffe9ae125b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxkYXJrJTIwZ2xvd2luZyUyMG5vZGVzJTIwZGF0YSUyMG5ldHdvcmslMjBhYnN0cmFjdHxlbnwwfHx8fDE3OTIwNjkyNjZ8MA&ixlib=rb-4.1.0&q=85";

export const Proof = () => {
  return (
    <section
      data-testid="telemetry-section"
      className="max-w-6xl mx-auto px-6 py-24 border-b border-seam"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <span className="text-xs uppercase text-ember font-semibold tracking-wider">
            Telemetry &amp; Benchmarks
          </span>
          <h2 className="font-serif text-2xl sm:text-3xl text-white mt-1 mb-4">
            Transparent Metrics
          </h2>
          <p className="text-xs text-smoke leading-relaxed mb-6">
            We refrain from artificial benchmarks or invented user reviews.
            Actual telemetry logs from initial development teams will be
            published here upon release.
          </p>
          <div
            data-testid="telemetry-empty-state"
            className="p-4 rounded-lg border border-seam bg-ground text-xs text-smoke"
          >
            <span className="text-white font-medium">Telemetry status:</span>{" "}
            Awaiting initial cohort deployment logs.
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="aspect-video w-full rounded-xl border border-seam relative overflow-hidden">
            <img
              src={PROOF_IMAGE}
              alt="Minimalist benchmark frame awaiting developer verification logs"
              className="flint-drift absolute inset-0 w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-ground/70" />
            <div className="absolute inset-0 p-6 flex flex-col justify-center items-center text-center">
              <div className="text-xs font-mono text-ember mb-2">
                [Cohort 01 Telemetry Stream]
              </div>
              <div className="text-white text-sm font-semibold max-w-sm mb-3">
                Live token savings benchmarks will stream here during public
                beta.
              </div>
              <span className="text-[11px] text-smoke border border-seam px-3 py-1 rounded bg-black/40">
                Early access cohort opening soon
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
